module.exports = __webpack_public_path__ + "9fd7e5ecba64855ff8de397b0dba8cef.pdf";